module.exports = __webpack_public_path__ + "static/hr_capabilities_10-a6bb60fd8061a590d6395b27d9fd23df.png";